import { Fragment, useState } from 'react';
import { getDaisyDepositIntervals } from '../../api/getDaisyDepositIntervals';
import { Entity, SummarizationInfo } from '../../models/types/DaisyDepositIntervals';
import { currencyFormatter } from '../../utils/currencyFormatter';
import { responseHero } from '../../utils/axiosInterceptor';
import { toast } from 'react-toastify';
import React from 'react';
import { User } from '../../models/user.model';
import { Organization } from '../../models/organization.model';
import { makeContract } from '../../api/makeContract';
import { DaisyContractDetail } from '../../types/daisyContractDetail';
import { getCompanyDetails } from '../../api/getCompanyDetails';
import { getEnvelopesWithGroup } from '../../api/getEnvelopesWithGroup';
import { Envelope } from '../../models/envelope.model';
import { useNavigate } from 'react-router';
import { getUserActiveCryptoAccount, getUserCryptoAccounts } from '../../api/getAccounts';

// május 31. (human d.c. kifizetések is)

const fixedStartDate = '2021-06-22';

export const options = [
  {
    id: 1,
    name: '1. csoport',
    caption: '3 év, vagy annál több',
    startDate: fixedStartDate,
    endDate: '2022-05-31',
    paymentDeadline: '2025-09-30',
  },
  {
    id: 2,
    name: '2. csoport',
    caption: '2-3 év között',
    startDate: '2022-06-01',
    endDate: '2023-05-31',
    paymentDeadline: '2025-12-31',
  },
  {
    id: 3,
    name: '3. csoport',
    caption: '1-2 év között',
    startDate: '2023-06-01',
    endDate: '2024-06-01',
    paymentDeadline: '2026-03-30',
  },
];

export type ContractDetail = {
  user: User;
  year_category_id: number;
  year_category: string;
  until_date: string;
  deposit: number;
  withdraw: number;
  diff: number;
  remainingAmount: number;
  currency: string;
}



export default function DaisyDepositIntervalPage() {

  const [selectedOptionIndex, setSelectedOptionIndex] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const [result, setResult] = useState<Entity[]>();
  const [envelopes, setEnvelopes] = useState<Envelope[]>([]);
  const [loading, setLoading] = useState(false);

  // --- ÚJ: state a név-keresőhöz ---
  const [nameQuery, setNameQuery] = useState("");

  const [payoutRelevanceMap, setPayoutRelevanceMap] = useState<Record<string, boolean>>({});
  const [loadingPayouts, setLoadingPayouts] = useState<Record<number, boolean>>({});

  const [contractDetails, setContractDetails] = React.useState<Map<string, ContractDetail>>();

  const [signingUrl, setSigningUrl] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);
  
  const navigate = useNavigate();


  const normalize = (s?: string) =>
    (s ?? "")
      .toLocaleLowerCase("hu")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  // --- MÓDOSÍTÁS: filteredResults bővítése név szűréssel ---
const filteredResults = React.useMemo(() => {
  if (!result) return [];
  const startDate = new Date(options[selectedOptionIndex].startDate);
  const endDate = new Date(options[selectedOptionIndex].endDate);
  const q = normalize(nameQuery.trim());

  return result.filter(dep => {
    const targetDate = new Date(dep.date);
    const inRange = targetDate >= startDate && targetDate <= endDate;
    if (!inRange) return false;

    // ha nincs keresőkifejezés, minden dátum-szűrt elem marad
    if (!q) return true;

    // név szerinti szűrés (ékezet- és kis/nagybetű független)
    return normalize(dep.user?.name).includes(q);
  });
}, [result, selectedOptionIndex, nameQuery]);


  const sortedResults = React.useMemo(() => {
    if (!filteredResults || !contractDetails) return filteredResults;
  
    return [...filteredResults].sort((a, b) => {
      const aKey = `${a.user_id}-${a.group_id}-${options[selectedOptionIndex].id}`;
      const bKey = `${b.user_id}-${b.group_id}-${options[selectedOptionIndex].id}`;
  
      const aHasEnvelope = envelopes.some(env => env.user_id === a.user_id && env.group_id === a.group_id && env.status !== 'voided');
      const bHasEnvelope = envelopes.some(env => env.user_id === b.user_id && env.group_id === b.group_id && env.status !== 'voided');
  
      // Akinek NINCS envelope-ja, az kerüljön előrébb
      if (!aHasEnvelope && bHasEnvelope) return -1;
      if (aHasEnvelope && !bHasEnvelope) return 1;
  
      // Egyébként ne változzon a sorrend
      return 0;
    });
  }, [filteredResults, envelopes, contractDetails, selectedOptionIndex]);
  
  

  const recalculateContractDetails = (
    currentMap: Map<string, ContractDetail>,
    allEntities: Entity[],
    relevanceMap: Record<string, boolean>
  ) => {
    const detailsArray = Array.from(currentMap.entries()).map(([key, value]) => {
      const [userId, groupId] = key.split("-").map((x) => parseInt(x, 10));
      return {
        key,
        userId,
        groupId,
        ...value
      };
    });
  
    const grouped: Record<string, typeof detailsArray> = {};
    detailsArray.forEach((item) => {
      const groupKey = `${item.userId}-${item.groupId}`;
      if (!grouped[groupKey]) grouped[groupKey] = [];
      grouped[groupKey].push(item);
    });
  
    const updatedMap = new Map<string, ContractDetail>();
  
    //console.log("🔍 --- Újratervezés START ---");
    Object.entries(grouped).forEach(([groupKey, items]) => {
      // console.log(`\n👤 Feldolgozás: ${groupKey} (${items.length} intervallum)`);
  
      const sortedItems = items.sort((a, b) => a.year_category_id - b.year_category_id);
      let carryOver = 0;
  
      sortedItems.forEach((item, index) => {
        let newWithdraw = 0;
  
        if (index === 0) {
          //console.log(`➡️ Első intervallum (${item.year_category_id}) → payout számolás`);
          const payouts = allEntities
            .filter((e) => e.user_id === item.userId && e.group_id === item.groupId)
            .flatMap((e) => e.payouts);
  
          const seen = new Set<number>();
          payouts.forEach((p, i) => {
            const payoutKey = `${item.userId}-${item.groupId}-${item.year_category_id}-${i}`;
            const isRelevant = relevanceMap[payoutKey] ?? p.relevance;
            if (isRelevant && !seen.has(p.id)) {
              newWithdraw += p.valEur;
              seen.add(p.id);
            }
          });
  
          //console.log(`💰 Payout összeg: ${newWithdraw.toFixed(2)} EUR`);
        } else {
          //console.log(`➡️ Nem első intervallum (${item.year_category_id}) → withdraw = 0`);
        }
  
        const newDiff = index === 0 ? item.deposit - newWithdraw : item.deposit + carryOver;
  
        /*
        console.log(
          `📌 Intervallum: ${item.year_category} | Deposit: ${item.deposit.toFixed(2)} | Withdraw: ${newWithdraw.toFixed(2)} | CarryOver előtte: ${carryOver.toFixed(2)} | Diff: ${newDiff.toFixed(2)}`
        );
        */
  
        carryOver = newDiff < 0 ? newDiff : 0;
  
        updatedMap.set(item.key, {
          ...item,
          withdraw: newWithdraw,
          diff: newDiff
        });
      });
    });
  
    // console.log("✅ --- Újratervezés END ---");
  
    return updatedMap;
  }; 


  const calculateRelevantPayoutSum = React.useCallback((groupKey: string, payouts: Entity["payouts"]) => {
    const seen = new Set<number>();
    let sum = 0;
  
    payouts.forEach((p, i) => {
      const key = `${groupKey}-${i}`;
      const isRelevant = payoutRelevanceMap[key] ?? p.relevance;
      if (isRelevant && !seen.has(p.id)) {
        sum += p.valEur;
        seen.add(p.id);
      }
    });
  
    return sum;
  }, [payoutRelevanceMap]);
  

  
  // ------------------- PÉNZMÓDOSÍTÁS (TOGGLE) -------------------

  async function togglePayoutStatus(payoutId: number): Promise<boolean> {
    try {
      const res = await responseHero.get(`${process.env.REACT_APP_API_URL}/togglePayout/${payoutId}`);
      return true; // siker esetén
    } catch (error) {
      console.error("API error:", error);
      throw error; // A hívó kezeli a hibát
    }
  }

  const togglePayoutRelevance = async (payoutId: number, payoutKey: string) => {
    if (loadingPayouts[payoutId]) return; // Ha már folyamatban, ne engedd újra
  
    // Jelöljük betöltés alattinak
    setLoadingPayouts((prev) => ({ ...prev, [payoutId]: true }));
  
    const prevMap = payoutRelevanceMap;
    const currentValue = prevMap[payoutKey] ?? false;
    const newValue = !currentValue;
  
    setPayoutRelevanceMap((prev) => {
      const updatedMap = { ...prev };
  
      Object.keys(updatedMap).forEach((key) => {
        if (key.includes(`-${payoutId}-`)) {
          updatedMap[key] = newValue;
        }
      });
  
      updatedMap[payoutKey] = newValue;
  
      setContractDetails((prevDetails) =>
        prevDetails ? recalculateContractDetails(new Map(prevDetails), result || [], updatedMap) : prevDetails
      );
  
      return updatedMap;
    });
  
    try {
      await togglePayoutStatus(payoutId);
    } catch (error) {
      console.error(error);
      toast.error("Nem sikerült frissíteni az adatbázisban!");
      setPayoutRelevanceMap(prevMap);
      setContractDetails((prevDetails) =>
        prevDetails ? recalculateContractDetails(new Map(prevDetails), result || [], prevMap) : prevDetails
      );
    } finally {
      setLoadingPayouts((prev) => {
        const updated = { ...prev };
        delete updated[payoutId];
        return updated;
      });
    }
  };
  
  
  
  
  
  React.useEffect(() => {
    if (!contractDetails) return;
  
    const detailsArray = Array.from(contractDetails.entries()).map(([key, value]) => {
      const [userId, groupId] = key.split("-");
      return {
        key,
        userId: parseInt(userId, 10),
        groupId: parseInt(groupId, 10),
        ...value
      };
    });
  
    const grouped: Record<string, typeof detailsArray> = {};
    detailsArray.forEach((item) => {
      const groupKey = `${item.userId}-${item.groupId}`;
      if (!grouped[groupKey]) grouped[groupKey] = [];
      grouped[groupKey].push(item);
    });
  
    const duplicates = Object.entries(grouped)
      .filter(([_, items]) => items.length > 1)
      .map(([key, items]) => ({
        userGroup: key,
        userNames: items.map((i) => i.user.name),
        records: items
      }));
  
    if (duplicates.length > 0) {
      console.log("⚠️ Több intervallumban szereplők:", duplicates);
    }
  }, [contractDetails]);

  
  // ------------------- ADATBETÖLTÉS -------------------
  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const firstDate = options[0].startDate;
        const endDate = options[options.length - 1].endDate;

        const res = await getDaisyDepositIntervals(firstDate, endDate);
        setResult(res.entities);

        const envs = await getEnvelopesWithGroup();
        setEnvelopes(envs);

        const detailsMap = new Map<string, ContractDetail>();
        res.entities.forEach((e) => {
          const { id, name, paymentDeadline } = getYearCategory(e.date);
          const groupKey = `${e.user_id}-${e.group_id}-${id}`;

          if (detailsMap.has(groupKey)) {
            const existing = detailsMap.get(groupKey)!;
            detailsMap.set(groupKey, {
              ...existing,
              deposit: existing.deposit + e.depositInEur,
            });
          } else {
            detailsMap.set(groupKey, {
              user: e.user,
              year_category: name,
              year_category_id: id,
              until_date: paymentDeadline,
              deposit: e.depositInEur,
              withdraw: 0,
              diff: 0,
              remainingAmount: 0,
              currency: 'EUR',
            });
          }
        });

        setContractDetails(recalculateContractDetails(detailsMap, res.entities, payoutRelevanceMap));
      } catch (error) {
        console.error(error);
        toast.error("Hiba történt az adatok lekérése közben.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  

  const getYearCategory = (date: Date) => {
    // Ensure we work with the date only (remove time part)
    const targetDate = new Date(date.toString().split('T')[0]);
  
    for (const opt of options) {
      const startDate = new Date(opt.startDate); // yyyy-mm-dd format -> Date
      const endDate = new Date(opt.endDate);
  
      if (targetDate >= startDate && targetDate <= endDate) {
        return {
          id: opt.id,
          name: opt.name,
          paymentDeadline: opt.paymentDeadline
        };
      }
    }

    return {
      id: -1,
      name: "Nincs kategória",
      paymentDeadline: ""
    };
  };

  const noEnvelopeSummary = React.useMemo(() => {
    if (!contractDetails || !result) return { totalDiff: 0, count: 0 };
  
    let totalDiff = 0;
    let count = 0;
  
    const startDate = new Date(options[selectedOptionIndex].startDate);
    const endDate = new Date(options[selectedOptionIndex].endDate);

    const filteredEntities = result.filter((e) => {
      const targetDate = new Date(e.date);
      return targetDate >= startDate && targetDate <= endDate;
    });
  
    const includedKeys = new Set<string>();
    filteredEntities.forEach((e) => {
      const { id: year_category_id } = getYearCategory(e.date);
      includedKeys.add(`${e.user_id}-${e.group_id}-${year_category_id}`);
    });
  
    contractDetails.forEach((detail, key) => {
      if (!includedKeys.has(key)) return;
  
      const [userIdStr, groupIdStr] = key.split("-");
      const userId = parseInt(userIdStr, 10);
      const groupId = parseInt(groupIdStr, 10);
  
      const hasEnvelope = envelopes.some(
        (env) => env.user_id === userId && env.group_id === groupId
      );
  
      if (!hasEnvelope && detail.diff > 0) {
        totalDiff += detail.diff;
        count += 1;
      }
    });
  
    return { totalDiff, count };
  }, [contractDetails, envelopes, result, selectedOptionIndex]);

  const processContract = async (user: User | undefined, org: Organization | undefined, currency: string, amount: number, template_ref_id: string | undefined, daisyContractDetail?: DaisyContractDetail) => {
    
    const companyDetails = await getCompanyDetails();

    try {
      toast.info("A szerződés előállítása megkezdődött, kérlek várj...")

      const lendAmount = 0;

      const accountData = user ? await getUserActiveCryptoAccount(user?.user_id) : null;

      await makeContract(
        user, 
        org, 
        companyDetails, 
        currency, 
        amount,
        lendAmount,
        template_ref_id,
        accountData,
        "",
        daisyContractDetail,
      ).then((res) => {
          setSigningUrl(res);
          setShowModal(true);
      }).catch((err: any) => {
        console.error(err)
      })
    } catch (err) {
      console.error(err)
    }
    
  }

  return (
    <>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
            <h2 className="text-xl font-semibold mb-4 text-dark-blue">A szerződés elkészült a DocuSign rendszerében.</h2>
            <p className="mb-4 text-sm text-gray-700 break-all">A zöld gomb megnyomásával lépjen tovább.</p>

            <div className="flex justify-end space-x-2">
              <a
                href={signingUrl ?? "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 text-center hover:bg-green-700 text-white px-4 py-2 rounded"
              >
                Irány a DocuSign, a szerződés aláírásához!
              </a>
              <button
                onClick={() => setShowModal(false)}
                className="bg-gray-300 text-center hover:bg-gray-400 text-gray-800 px-4 py-2 rounded"
              >
                Vissza
              </button>
            </div>
          </div>
        </div>
      )}


      <div className="overflow-x-auto m-10">

      <div className="bg-white p-4 rounded-lg shadow mb-2 flex gap-4 items-end">
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Időintervallum</label>
          <select
            value={selectedOptionIndex}
            onChange={(e) => setSelectedOptionIndex(parseInt(e.target.value))}
            className="border px-3 py-2 rounded w-full"
          >
            {options.map((opt, idx) => (
              <option key={idx} value={idx}>
                {opt.caption}
              </option>
            ))}
          </select>
        </div>

        {/* ÚJ: Név szerinti kereső */}
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Keresés név szerint</label>
          <input
            type="text"
            value={nameQuery}
            onChange={(e) => setNameQuery(e.target.value)}
            placeholder="Pl.: Kovács"
            className="border px-3 py-2 rounded w-full"
          />
        </div>
      </div>


        
        {/*
        {filteredSummary && (
          <>
          
          <div className="flex items-center mb-2 space-x-8">
            <p className='bg-dark-blue text-gray-200 py-2 px-2 rounded-md'>Összes befizetés az időszakban: 
              <span className='font-semibold text-cream'> {currencyFormatter(filteredSummary?.totalDeposits, 'USD')}</span></p>
            <p className='bg-dark-blue text-gray-200 py-2 px-2 rounded-md'>Összes kifizetés az időszakban: 
              <span className='font-semibold text-cream'> {currencyFormatter(filteredSummary?.totalWithdrawals, 'USD')}</span></p>
            <p className='bg-dark-blue text-gray-200 py-2 px-2 rounded-md'>Különbség: 
              <span className='font-semibold text-cream'> {currencyFormatter(filteredSummary?.totalDifference, 'USD')}</span></p>
          </div>

          <div className="flex items-center mb-2 space-x-8">
            <p className='bg-dark-blue text-gray-200 py-2 px-2 rounded-md'>Összes befizetés az időszakban (EUR): 
              <span className='font-semibold text-cream'> {currencyFormatter(filteredSummary?.totalDepositsEur, 'EUR')}</span></p>
            <p className='bg-dark-blue text-gray-200 py-2 px-2 rounded-md'>Összes kifizetés az időszakban (EUR): 
              <span className='font-semibold text-cream'> {currencyFormatter(filteredSummary?.totalWithdrawalsEur, 'EUR')}</span></p>
            <p className='bg-dark-blue text-gray-200 py-2 px-2 rounded-md'>Különbség (EUR): 
              <span className='font-semibold text-cream'> {currencyFormatter(filteredSummary?.totalDifferenceEur, 'EUR')}</span></p>
          </div>
          </>
          
        )}
        */}

        {noEnvelopeSummary.count > 0 && (
          <div className="bg-cream text-dark-blue rounded-lg shadow-md p-4 mb-4 w-full max-w-xl">
            <p className="text-lg font-semibold mb-1">⚠️ Figyelem</p>
            <p className="text-sm">
              {noEnvelopeSummary.count} felhasználónál nincs még kiküldött opciós szerződés, de pozitív különbözete van.
            </p>
            <p className="text-sm mt-2">
              <span className="font-semibold">Összes különbözet:</span>{" "}
              {currencyFormatter(noEnvelopeSummary.totalDiff, "EUR")}
            </p>
          </div>
        )}

        <div className="mb-2">
          <button
          onClick={() => navigate('/daisyintervalscontracts')}
            type="submit"
            className="text-center bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-800"
          >
            Megtekintem a már kiküldött szerződések eredményeit.
          </button>
        </div>

        {loading ? (
        <p className='text-2xl text-center animation-pulse'>Kérlek várj a befizetések betöltéséig...</p>
        ) : (
        <>
  
        <div className="flex items-center mb-2">
          <input
            id="togglePayouts"
            type="checkbox"
            checked={expanded}
            onChange={() => setExpanded((prev) => !prev)}
            className="mr-2 accent-brown"
          />
          <label htmlFor="togglePayouts" className="text-md text-gray-700">
            Minden rögzített kifizetés megjelenítése minden befizetőnél.
          </label>
        </div>

        <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">
          <thead className="bg-brown text-white">
            <tr>
              <th className="px-4 py-2 text-left text-sm">Dátum</th>
              <th className="px-4 py-2 text-left text-sm">Felhasználó</th>
              <th className="px-4 py-2 text-left text-sm">Csoport-részesedés</th>
              <th className="px-4 py-2 text-left text-sm">D.A.I.SY Csoport</th>
              <th className="px-4 py-2 text-left text-sm">Kifizetési Csoport</th>
              <th className="px-4 py-2 text-right text-sm">Befizetett Összeg (USD)</th>
              <th className="px-4 py-2 text-right text-sm">Befizetett Összeg (EUR)</th>
              <th className="px-4 py-2 text-right text-sm">Kifizetés (USD)</th>
              <th className="px-4 py-2 text-right text-sm">Kifizetés (EUR)</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {sortedResults?.map((dep, index) => (
              <Fragment key={index}>
                <tr className="hover:bg-gray-50">
                  <td className="px-4 py-2 text-sm text-gray-800">
                    {new Date(dep.date).toLocaleDateString()}
                  </td>
                  <td className="px-4 py-2 text-sm font-semibold text-gray-800">
                    {dep.user.name}
                  </td>
                  <td className="px-4 py-2 text-sm font-semibold text-gray-800">
                    {(dep.share * 100).toFixed(2)}%
                  </td>
                  <td className="px-4 py-2 text-sm text-gray-800">
                    {dep.groupName}
                  </td>
                  <td className="px-4 py-2 text-sm text-gray-800">
                    {options[selectedOptionIndex].name}
                  </td>
                  <td className="px-4 py-2 text-sm text-right text-gray-800">
                    {currencyFormatter(dep.deposit, 'USD')}
                  </td>
                  <td className="px-4 py-2 text-sm text-right text-gray-800">
                    {currencyFormatter(dep.depositInEur, 'EUR')}
                  </td>
                  <td className="px-4 py-2 text-sm text-right text-gray-800 font-semibold">
                    {currencyFormatter(dep.totalPayout, 'USD')}
                  </td>
                  <td className="px-4 py-2 text-sm text-right text-gray-800 font-semibold">
                    {currencyFormatter(dep.totalPayoutEur, 'EUR')}
                  </td>
                </tr>

                {expanded && (
                  <tr className="bg-gray-300">
                    <td colSpan={4} className="px-4 py-2 text-md text-gray-500">
                      <div>
                        <strong>Kifizetések részletei:</strong>

                        {dep.payouts.length > 0 ? 
                        <table className="mt-2 text-left text-sm">
                          <thead>
                            <tr className="text-gray-600 border-b border-gray-300">
                              <th className="py-1 pr-4 text-center">Kijelölés</th>
                              <th className="py-1 pr-4">Típus</th>
                              <th className="py-1 pr-4">Honnan</th>
                              <th className="py-1 pr-4">Dátum</th>
                              <th className="py-1 text-right">Összeg (USD)</th>
                              <th className="py-1 text-right">Összeg (EUR)</th>
                            </tr>
                          </thead>
                          <tbody className='border-b-2 border-gray-600'>
                            {dep.payouts.map((p, i) => (
                              <tr key={i} className="text-gray-800">
                                
                                <td className="py-1 pr-4 flex items-center justify-center">
                                <input
                                  type="checkbox"
                                  disabled={loadingPayouts[p.id]} // Ha API folyamatban → tiltjuk
                                  className="mr-2 accent-brown w-4 h-4"
                                  checked={payoutRelevanceMap[
                                    `${dep.user_id}-${dep.group_id}-${options[selectedOptionIndex].id}-${i}`
                                  ] ?? p.relevance}
                                  onChange={() =>
                                    togglePayoutRelevance(
                                      p.id,
                                      `${dep.user_id}-${dep.group_id}-${options[selectedOptionIndex].id}-${i}`
                                    )
                                  }
                                />


                                </td>


                                <td className="py-1 pr-4">{p.payout}</td>
                                <td className="py-1 pr-4">{p.currency ? 'Crypto' : 'Forex'}</td>
                                <td className="py-1 pr-4">
                                  {new Date(p.date).toLocaleDateString()}
                                </td>
                                <td className="py-1 text-right">
                                  {currencyFormatter(p.val, 'USD')}
                                </td>
                                <td className="py-1 text-right">
                                  {currencyFormatter(p.valEur, 'EUR')}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        :
                        <p>Nem található kifizetés.</p>
                        }
                      </div>
                    </td>
                    <td colSpan={5} className="px-4 py-2 text-md text-gray-500 space-y-4">
                      {(() => {
                        const groupKey = `${dep.user_id}-${dep.group_id}-${options[selectedOptionIndex].id}`;
                        const detail = contractDetails?.get(groupKey);
                        if (!detail) {
                          console.log("No detail found for groupKey:", groupKey + " detail: " + JSON.stringify(detail));
                          return null;
                        }

                        const relevantEnvelopes = envelopes.filter(
                          (env) => env.group_id === dep.group_id && env.user_id === dep.user_id && env.status !== 'voided'
                        );

                        return (
                          <ContractDetailsCard
                            detail={detail}
                            dep={dep}
                            groupKey={groupKey}
                            relevantEnvelopes={relevantEnvelopes}
                            calculateRelevantPayoutSum={calculateRelevantPayoutSum}
                            selectedOptionIndex={selectedOptionIndex}
                            processContract={processContract}
                            payoutRelevanceMap={payoutRelevanceMap}
                          />
                        );
                      })()}
                    </td>

                  </tr>
                )}
              </Fragment>
            ))}
          </tbody>
        </table>
        </>
        )}
      </div>
    </>

  );
}

// Contract Details

type ContractDetailsCardProps = {
  detail: ContractDetail;
  dep: Entity;
  groupKey: string;
  relevantEnvelopes: Envelope[];
  calculateRelevantPayoutSum: (groupKey: string, payouts: Entity["payouts"]) => number;
  selectedOptionIndex: number;
  processContract: (
    user: User | undefined,
    org: Organization | undefined,
    currency: string,
    amount: number,
    template_ref_id: string | undefined,
    daisyContractDetail?: DaisyContractDetail
  ) => void;
  payoutRelevanceMap: Record<string, boolean>;
};

const ContractDetailsCard: React.FC<ContractDetailsCardProps> = ({
  detail,
  dep,
  groupKey,
  relevantEnvelopes,
  calculateRelevantPayoutSum,
  selectedOptionIndex,
  processContract,
  payoutRelevanceMap
}) => {

  const relevantPayout = detail.withdraw; // Ez már recalculált érték
  const diff = detail.diff;

  return (
    <div className='flex'>
      <div className='w-1/2 p-3'>
        <div className="text-sm mt-2 bg-cream text-dark-blue p-2 rounded">
        <p className="text-md font-semibold">A kifizetési szerződés adatai:</p>
        <p>
          <span className="font-semibold">Kulcs:</span> {groupKey}
        </p>
        <p>
          <span className="font-semibold">Név:</span> {detail.user.name}
        </p>
        <p>
          <span className="font-semibold">Kifizetési csoport kategória:</span> {detail.year_category}
        </p>
        <p>
          <span className="font-semibold">Befizetés (EUR):</span>{" "}
          {currencyFormatter(detail.deposit, "EUR")}
        </p>
        <p>
          <span className="font-semibold">Kifizetés (EUR):</span>{" "}
          {currencyFormatter(relevantPayout, "EUR")}
        </p>
        <p>
          <span className="font-semibold">Különbség (EUR):</span>{" "}
          {currencyFormatter(diff, "EUR")}
        </p>

        {relevantEnvelopes.length > 0 && (
          <div className="border border-dark-blue mb-2 flex px-2 py-2 items-center justify-center">
            <p className="text-md text-center text-dark-blue">
              Figyelem: Ehhez az Ügyfélhez, ebben a csoportban már küldtünk ki{" "}
              <span className="font-semibold">{relevantEnvelopes.length}db </span>
              opció választásra vonatkozó szerződést!
            </p>
          </div>
        )}

        <button
          onClick={() =>
            processContract(detail.user, undefined, "EUR", detail.deposit, process.env.REACT_APP_TEMPLATE_DAISY_WITHDRAW_OPTIONS, {
              year_category_id: options[selectedOptionIndex].id,
              year_category: detail.year_category,
              until_date: detail.until_date,
              deposit: detail.deposit,
              withdraw: relevantPayout,
              diff: diff,
              group_id: dep.group_id,
              remainingAmount: 0
            })
          }
          className="hover:bg-green-800 rounded-md w-full px-2 py-2 bg-green-600 text-gray-200"
        >
          Kifizetési opciós szerződés előállítása
        </button>
      </div>
      </div>
    </div>
  );
};
